import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { CloseCircleIcon } from 'components/ui/icons/CloseCircleIcon';
import { EyeIcon } from 'components/ui/icons/EyeIcon';
import { LineHeight24Icon } from 'components/ui/icons/LineHeight24Icon';
import { PicIcon } from 'components/ui/icons/PicIcon';
import { useRem } from 'hooks/useRem';
import { accessibilityParamsStore } from 'stores/root';

import SettingsGroup from './SettingsGroup';
import SettingsItem from './SettingsItem';

import s from './AccessibilityMenu.module.scss';

const AccessibilityMenu: React.FC = () => {
  const calcRem = useRem();

  const {
    isDefaultFontSize,
    isMediumFontSize,
    isLargeFontSize,
    reset: resetFontSize,
    setFontSizeMedium,
    setFontSizeLarge,
  } = accessibilityParamsStore.fontSizeStore;
  const {
    isDefaultLineHeight,
    isMediumLineHeight,
    isLargeLineHeight,
    reset: resetLineHeight,
    setLineHeightMedium,
    setLineHeightLarge,
  } = accessibilityParamsStore.lineHeightStore;
  const { isPictureBlock, togglePictureBlock } = accessibilityParamsStore.pictureBlockStore;
  const {
    isBaseColorScheme,
    isInverseColorScheme,
    isBlueColorScheme,
    isBeigeColorScheme,
    isGreenColorScheme,
    setColorSchemeInverse,
    setColorSchemeBlue,
    setColorSchemeBeige,
    setColorSchemeGreen,
    reset: resetColorScheme,
  } = accessibilityParamsStore.colorSchemeStore;
  const { close } = accessibilityParamsStore;

  return (
    <div className={s.root}>
      <SettingsGroup label="Шрифт">
        <SettingsItem active={isDefaultFontSize} onClick={resetFontSize} content="A" className={s.root__typo_regular} />
        <SettingsItem
          active={isMediumFontSize}
          onClick={setFontSizeMedium}
          content="A"
          className={s.root__typo_medium}
        />
        <SettingsItem active={isLargeFontSize} onClick={setFontSizeLarge} content="A" className={s.root__typo_large} />
      </SettingsGroup>
      <SettingsGroup label="Межстрочный интервал">
        <SettingsItem active={isDefaultLineHeight} onClick={resetLineHeight} content={<LineHeight24Icon size={16} />} />
        <SettingsItem
          active={isMediumLineHeight}
          onClick={setLineHeightMedium}
          content={<LineHeight24Icon size={18} />}
        />
        <SettingsItem
          active={isLargeLineHeight}
          onClick={setLineHeightLarge}
          content={<LineHeight24Icon size={20} />}
        />
      </SettingsGroup>
      <SettingsGroup label="Цвет">
        <SettingsItem
          active={isBaseColorScheme}
          onClick={resetColorScheme}
          content="Ц"
          className={s.root__color_base}
        />
        <SettingsItem
          active={isInverseColorScheme}
          onClick={setColorSchemeInverse}
          content="Ц"
          className={s.root__color_inverse}
        />
        <SettingsItem
          active={isBlueColorScheme}
          onClick={setColorSchemeBlue}
          content="Ц"
          className={s.root__color_blue}
        />
        <SettingsItem
          active={isBeigeColorScheme}
          onClick={setColorSchemeBeige}
          content="Ц"
          className={s.root__color_beige}
        />
        <SettingsItem
          active={isGreenColorScheme}
          onClick={setColorSchemeGreen}
          content="Ц"
          className={s.root__color_green}
        />
      </SettingsGroup>
      <SettingsGroup label="Изображения">
        <SettingsItem
          onClick={togglePictureBlock}
          content={
            isPictureBlock ? (
              <CloseCircleIcon size={calcRem({ desktop: 24 })} />
            ) : (
              <PicIcon size={calcRem({ desktop: 24 })} />
            )
          }
        />
      </SettingsGroup>
      <SettingsGroup label="Обычная версия">
        <SettingsItem onClick={close} content={<EyeIcon size={calcRem({ desktop: 24 })} />} />
      </SettingsGroup>
    </div>
  );
};

export default observer(AccessibilityMenu);
